<template>
  <div>
    <v-container fluid class="pa-3 pa-sm-6">
      <v-card class="mx-auto elevation-12 home-card" max-width="1200" shaped>
        <v-card-text class="pa-4 pa-sm-8">
          <v-progress-linear
            v-if="cargandoInstitucion"
            indeterminate
            color="primary"
            class="mb-4"
          ></v-progress-linear>

          <v-alert
            v-if="cargandoInstitucion"
            color="blue"
            dark
            outlined
            class="mb-4"
          >
            <v-icon left>mdi-loading mdi-spin</v-icon>
            Cargando datos de la institución...
          </v-alert>

          <v-stepper
            v-if="!cargandoInstitucion"
            v-model="step"
            vertical
            elevation="0"
            class="stepper-responsive"
          >
            <v-stepper-step
              :complete="step > 1"
              step="1"
              color="primary"
              complete-icon="mdi-check-circle"
              editable
              @click="volverAPaso(1)"
            >
              <span class="step-title">Seleccionar Obra Social</span>
              <small
                v-if="step > 1 && obraSocialSeleccionada"
                class="d-none d-sm-block"
              >
                {{ getNombreObraSocial() }}
              </small>
            </v-stepper-step>

            <v-stepper-content step="1">
              <v-card elevation="2" class="mb-4">
                <SeleccionarOS
                  :obrasSociales="obrasSociales"
                  :idInstitucion="$store.state.idInstitucion"
                  :tiposTurno="tiposTurno"
                  @obraSocialSeleccionada="seleccionarObraSocial"
                />
              </v-card>
            </v-stepper-content>

            <v-stepper-step
              :complete="step > 2"
              step="2"
              color="primary"
              complete-icon="mdi-check-circle"
              :editable="step > 2"
              @click="volverAPaso(2)"
            >
              <span class="step-title">Seleccionar Profesional</span>
              <small
                v-if="step > 2 && profesionalSeleccionado"
                class="d-none d-sm-block"
              >
                {{ profesionalSeleccionado.nombre }}
              </small>
            </v-stepper-step>

            <v-stepper-content step="2">
              <v-card elevation="2" class="mb-4">
                <BuscarProfesional
                  v-if="obraSocialSeleccionada"
                  :idObraSocial="obraSocialSeleccionada.obraSocial"
                  :tipoDeTurno="obraSocialSeleccionada.tipoDeTurno"
                  @profesionalSeleccionado="seleccionarProfesional"
                  @volver="step = 1"
                />
              </v-card>
            </v-stepper-content>

            <v-stepper-step
              :complete="step > 3"
              step="3"
              color="primary"
              complete-icon="mdi-check-circle"
            >
              <span class="step-title">Seleccionar Turno</span>
            </v-stepper-step>

            <v-stepper-content step="3">
              <v-card elevation="2" class="mb-4">
                <GestionTurnos
                  v-if="profesionalSeleccionado"
                  :idInstitucion="$store.state.idInstitucion"
                  :idProfesional="profesionalSeleccionado.idProfesional"
                  :nombreProfesional="profesionalSeleccionado.nombre"
                  :idObraSocial="obraSocialSeleccionada.obraSocial"
                  :tipoDeTurno="obraSocialSeleccionada.tipoDeTurno"
                  @volver="step = 2"
                  @turnoSeleccionado="abrirModalDatos"
                />
              </v-card>
            </v-stepper-content>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-container>
    <ModalDatosPaciente
      v-if="showModalDatos"
      :visible="showModalDatos"
      :turnoSeleccionado="turnoSeleccionado"
      :idProfesional="profesionalSeleccionado?.idProfesional"
      @close="showModalDatos = false"
      @turnoGuardado="turnoGuardado"
    />
  </div>
</template>

<style scoped>
.home-card {
  width: 100%;
}

.stepper-responsive {
  background: transparent !important;
  box-shadow: none !important;
}

.step-title {
  font-size: 1rem;
  font-weight: 500;
}

.v-stepper__step {
  padding: 24px;
}

.v-stepper__content {
  padding: 24px 24px 24px 60px;
}

/* Responsive para móviles */
@media (max-width: 600px) {
  .home-card {
    border-radius: 8px !important;
  }

  .step-title {
    font-size: 0.9rem;
  }

  .v-stepper__step {
    padding: 16px !important;
  }

  .v-stepper__content {
    padding: 16px 16px 16px 40px !important;
  }
}

@media (max-width: 400px) {
  .step-title {
    font-size: 0.85rem;
  }

  .v-stepper__step {
    padding: 12px !important;
  }

  .v-stepper__content {
    padding: 12px 12px 12px 36px !important;
  }
}

/* Ajustes para pantallas muy pequeñas */
@media (max-width: 360px) {
  .home-card {
    margin: 0 !important;
    border-radius: 0 !important;
  }
}
</style>

<script>
import axios from "../axios-auth.js";
import SeleccionarOS from "../components/SeleccionarOS.vue";
import BuscarProfesional from "../components/BuscarProfesional.vue";
import GestionTurnos from "../components/GestionTurnos.vue";
import ModalDatosPaciente from "../components/ModalDatosPaciente.vue";

export default {
  name: "Home",
  components: {
    SeleccionarOS,
    BuscarProfesional,
    GestionTurnos,
    ModalDatosPaciente,
  },
  props: {
    urlInstitucion: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      step: 1,
      obrasSociales: [],
      tiposTurno: [],
      obraSocialSeleccionada: null,
      profesionalSeleccionado: null,
      turnoSeleccionado: null,
      showModalDatos: false,
      cargandoInstitucion: false,
    };
  },
  watch: {
    step(newStep, oldStep) {
      // Si vuelve al paso 1 desde el paso 2 o 3, limpiar selecciones
      if (newStep === 1 && oldStep > 1) {
        this.obraSocialSeleccionada = null;
        this.profesionalSeleccionado = null;
        this.turnoSeleccionado = null;
      }
      // Si vuelve al paso 2 desde el paso 3, limpiar profesional y turno
      if (newStep === 2 && oldStep === 3) {
        this.profesionalSeleccionado = null;
        this.turnoSeleccionado = null;
      }
    },
  },
  mounted() {
    this.inicializarInstitucion();
  },
  methods: {
    volverAPaso(paso) {
      if (paso < this.step) {
        this.step = paso;
      }
    },
    getNombreObraSocial() {
      if (this.obraSocialSeleccionada && this.obrasSociales.length > 0) {
        const os = this.obrasSociales.find(
          (o) => o.idObraSocial === this.obraSocialSeleccionada.obraSocial,
        );
        return os ? os.nombre : "";
      }
      return "";
    },
    async inicializarInstitucion() {
      if (this.urlInstitucion) {
        this.cargandoInstitucion = true;
        this.$store.commit("setUrlInstitucion", this.urlInstitucion);

        try {
          const response = await axios.get("/Login/GetDatosInstitucion", {
            params: {
              urlInstitucion: this.urlInstitucion,
            },
          });

          this.$store.commit("setIdInstitucion", response.data.idInstitucion);
          this.$store.commit(
            "setNombreInstitucion",
            response.data.nombreInstitucion,
          );
          this.$store.commit("setUrlInstitucion", response.data.urlInstitucion);
          this.$store.commit("setEsEmpresa", response.data.esEmpresa);

          await this.cargarObrasSociales();
          await this.cargarTiposTurno();
        } catch (error) {
          console.error("Error al cargar datos de institución:", error);
          this.$swal.fire({
            icon: "error",
            title: "La institución no existe",
            text: "Por favor verifique la URL",
            showConfirmButton: true,
          });
          this.$router.push("/");
        } finally {
          this.cargandoInstitucion = false;
        }
      } else {
        this.cargarObrasSociales();
        this.cargarTiposTurno();
      }
    },
    cargarObrasSociales() {
      return axios
        .get("/PortalPublico/GetObraSocialActivasDeInstWeb", {
          params: {
            nombre: "",
            idInstitucion: this.$store.state.idInstitucion,
          },
        })
        .then((response) => {
          this.obrasSociales = response.data;
        })
        .catch((error) => {
          console.error("Error al cargar obras sociales:", error);
        });
    },
    cargarTiposTurno() {
      return axios
        .get("/PortalPublico/GetTiposTurno", {
          params: {
            idInstitucion: this.$store.state.idInstitucion,
          },
        })
        .then((response) => {
          this.tiposTurno = response.data;
        })
        .catch((error) => {
          console.error("Error al cargar tipos de turno:", error);
        });
    },
    seleccionarObraSocial(data) {
      this.obraSocialSeleccionada = data;
      this.$store.commit("setObraSocial", data);
      this.profesionalSeleccionado = null;
      this.turnoSeleccionado = null;
      this.step = 2;
    },
    seleccionarProfesional(profesional) {
      this.profesionalSeleccionado = profesional;
      this.turnoSeleccionado = null;
      this.step = 3;
    },
    abrirModalDatos(turno) {
      this.turnoSeleccionado = turno;
      this.showModalDatos = true;
    },
    turnoGuardado() {
      this.showModalDatos = false;
      this.step = 1;
      this.obraSocialSeleccionada = null;
      this.profesionalSeleccionado = null;
      this.turnoSeleccionado = null;
    },
  },
};
</script>
